import styled from 'styled-components'

export const GroupHeadingStyled = styled.div`
  background-color: ${props => props.theme.colors.neutral.lighter};
  padding: ${props => props.theme.spacings.medium} 0;
  & > div {
    color: ${props => props.theme.colors.secondary.base};
    margin: 0;
  }
`
